import React from 'react';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { PersonExtendedDataBlock } from '../../_blocks/PersonExtendedData/PersonExtendedDataBlock';
import { BlockType, WidgetType } from '../../types/api/ElementType';
import { ProfileImageBlock } from '../../_blocks/ProfileImage/ProfileImageBlock';
import { Widget } from '../../_lib/components/Widget';
import { PersonInteractionBlock } from '../../_blocks/PersonInteraction';
import { PersonVCardBlock } from '../../_blocks/PersonVCard/PersonVCardBlock';
import { isNonEmptyBlock } from '../../types/api/Block';
import { UserPageLeadBlock } from '../../_blocks/UserPageLead/UserPageLeadBlock';

type UserInfoBlocks =
  UserPageLeadBlock | ProfileImageBlock | PersonExtendedDataBlock | PersonInteractionBlock | PersonVCardBlock;

export type UserInfoWidget = WidgetShape<UserInfoBlocks[], WidgetType.userinfo>;
const getUserInfoBlocks = (block: UserInfoBlocks) => {
  switch (block.elementType) {
    case BlockType.userpagelead:
      return <UserPageLeadBlock key={block.uuid} {...block} />;
    case BlockType.profileimage:
      return <ProfileImageBlock key={block.uuid} {...block} />;
    case BlockType.personinteraction:
      return <PersonInteractionBlock key={block.uuid} {...block} />;
    case BlockType.personextendeddata:
    case BlockType.personcontactdata:
    case BlockType.personaffiliation:
    case BlockType.personadditionalinformation:
      return <PersonExtendedDataBlock key={block.uuid} {...block} />;
    case BlockType.personvcard:
      return <PersonVCardBlock key={block.uuid} {...block} />;
    default:
      return null;
  }
};

export function UserInfoWidget({ blocks, elementType, ...headerProps }: UserInfoWidget) {
  return (
    <Widget {...headerProps} isArticle widgetType={elementType}>
      {blocks.filter(isNonEmptyBlock).map(getUserInfoBlocks)}
    </Widget>
  );
}
